import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { getTunnelOvenDataWithLeaching } from "../GlovesTracking/services";
import dayjs from "dayjs";

const TunnelOven = ({setTunnelOvenPopup,batchId}) => {
      const [temperatures, setTemperatures] = useState([]);
        const [tunnelOvenData, setTunnelOvenData] = useState([]);
      useEffect(() => {
        if (tunnelOvenData.length > 0) {
          const tempValues = [
            tunnelOvenData[0].set_temp_zone1,
            tunnelOvenData[0].set_temp_zone2,
            tunnelOvenData[0].set_temp_zone3,
            tunnelOvenData[0].set_temp_zone4,
            tunnelOvenData[0].set_temp_zone5,
            tunnelOvenData[0].set_temp_zone6,
            tunnelOvenData[0].set_temp_zone7,
            tunnelOvenData[0].set_temp_zone8,
          ].map((temp) => parseFloat(temp)); // Convert to number
          setTemperatures(tempValues);
        }
      }, [tunnelOvenData]);

      useEffect(()=>{
        handleGetTunnelOven()
      },[batchId])

        const handleGetTunnelOven = async () => {
          try {
            const resp = await getTunnelOvenDataWithLeaching(batchId);
            if (resp.status == 200 || resp.status == 201) {
                setTunnelOvenData(resp.data.payload);
            }
          } catch (error) {
            toast.error(error.response.data.message);
            setTunnelOvenData([]);
            console.log("handlesubmit", error);
          }
        };
  return (
    <>
    <div
      className="modal-container"
      style={{ height: "40vh", top: "35vh" }}
    >
      <div className="modal-header">
        <div className="modal-title">TUNNEL OVEN PROCESS SHEET</div>
        <div
          onClick={() => setTunnelOvenPopup(false)}
          style={{ cursor: "pointer" }}
        >
          <CloseIcon />
        </div>
      </div>
      <div className="modal-table-wrapper">
        <Box sx={{ p: 2 }} style={{ float: "right" }}>
          {/* Temperature Inputs */}
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Typography
                variant="subtitle1"
                className="mb-1"
                style={{ fontWeight: "bold" }}
              >
                Zone:
              </Typography>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: "bold" }}
              >
                Set temp (°C):
              </Typography>
            </Grid>
            {temperatures.map((temp, index) => (
              <Grid item key={index}>
                <Typography variant="subtitle1" className="mb-1">
                  {index + 1}
                </Typography>
                <TextField
                  // type="number"
                  variant="outlined"
                  size="small"
                  value={temp}
                  style={{ pointerEvents: "none" }}
                  // onChange={(e) =>
                  //   handleTemperatureChange(index, e.target.value)
                  // }
                  sx={{ width: 60 }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <div
          style={{
            width: "100%",
            overflow: "auto",
            maxHeight: "400px",
          }}
          className="gloves-report-data"
        >
          <Table className="gloves-params">
            <TableHead>
              <TableRow>
                <TableCell rowSpan={2}>IN FEED</TableCell>
                <TableCell rowSpan={2}>OUT FEED</TableCell>
                <TableCell colSpan={3}>Hot leaching</TableCell>
                <TableCell colSpan={2}>Cold leaching</TableCell>
                <TableCell colSpan={2}>Tunnel oven</TableCell>
                <TableCell colSpan={9}>
                  TUNNEL OVEN ACTUAL TEMPERATURE ZONE WISE
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Temp (°C)</TableCell>
                <TableCell>Start</TableCell>
                <TableCell>End</TableCell>
                <TableCell>Start</TableCell>
                <TableCell>End</TableCell>
                <TableCell>Start</TableCell>
                <TableCell>End</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Zone 1</TableCell>
                <TableCell>Zone 2</TableCell>
                <TableCell>Zone 3</TableCell>
                <TableCell>Zone 4</TableCell>
                <TableCell>Zone 5</TableCell>
                <TableCell>Zone 6</TableCell>
                <TableCell>Zone 7</TableCell>
                <TableCell>Zone 8</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tunnelOvenData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {row.in_feed
                      ? dayjs(row.in_feed).isValid()
                        ? dayjs(row.in_feed).format("HH:mm:ss")
                        : "--"
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.out_feed
                      ? dayjs(row.out_feed).isValid()
                        ? dayjs(row.out_feed).format("HH:mm:ss")
                        : "--"
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.leaching_data?.hot_leach_set_temp || "--"}
                  </TableCell>
                  <TableCell>
                    {row.leaching_data?.hot_leach_cycle_start_time &&
                    dayjs(
                      row.leaching_data.hot_leach_cycle_start_time
                    ).isValid()
                      ? dayjs(
                          row.leaching_data.hot_leach_cycle_start_time
                        ).format("HH:mm:ss")
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.leaching_data?.hot_leach_cycle_end_time &&
                    dayjs(
                      row.leaching_data.hot_leach_cycle_end_time
                    ).isValid()
                      ? dayjs(
                          row.leaching_data.hot_leach_cycle_end_time
                        ).format("HH:mm:ss")
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.leaching_data?.cold_leach_cycle_start_time &&
                    dayjs(
                      row.leaching_data.cold_leach_cycle_start_time
                    ).isValid()
                      ? dayjs(
                          row.leaching_data
                            .cold_leach_cycle_start_time
                        ).format("HH:mm:ss")
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.leaching_data?.cold_leach_cycle_end_time &&
                    dayjs(
                      row.leaching_data.cold_leach_cycle_end_time
                    ).isValid()
                      ? dayjs(
                          row.leaching_data.cold_leach_cycle_end_time
                        ).format("HH:mm:ss")
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.cycle_start_time &&
                    dayjs(row.cycle_start_time).isValid()
                      ? dayjs(row.cycle_start_time).format("HH:mm:ss")
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.cycle_end_time &&
                    dayjs(row.cycle_end_time).isValid()
                      ? dayjs(row.cycle_end_time).format("HH:mm:ss")
                      : "--"}
                  </TableCell>
                  <TableCell>
                    {row.cycle_end_time &&
                    dayjs(row.cycle_end_time).isValid()
                      ? dayjs(row.cycle_end_time).format("HH:mm:ss")
                      : "--"}
                  </TableCell>
                  {[
                    row.actual_temp_zone1,
                    row.actual_temp_zone2,
                    row.actual_temp_zone3,
                    row.actual_temp_zone4,
                    row.actual_temp_zone5,
                    row.actual_temp_zone6,
                    row.actual_temp_zone7,
                    row.actual_temp_zone8,
                  ].map((zone, zoneIndex) => (
                    <TableCell key={zoneIndex}>
                      {zone || "--"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
    <div
      className="modal-overlay"
      onClick={() => setTunnelOvenPopup(false)}
    ></div>
  </>
  );
}

export default TunnelOven;